/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { StructurePeopleResultDto } from '../models';
// @ts-ignore
import type { SupervisorAxisDto } from '../models';
/**
 * StructureBrowserApi - axios parameter creator
 * @export
 */
export const StructureBrowserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zasila przegladarke struktury w panelu admina. Zwraca wylacznie osoby, na ktore da sie zalogowac: aktywnego pracownika z wlaczonym kontem i przynajmniej jedna nadana rola. Bez wskazanej osoby wracaja ci, ktorzy maja kogos pod soba; ze wskazana — jej ludzie. Odczyt wylacznie dla administratora: pokazuje przypisane role, ktore nie naleza do danych ogladanych przez przelozonych. 
         * @summary People in the org structure with their account state (JAIN-489)
         * @param {SupervisorAxisDto} [axis] SUPERVISOR to linia przelozonych, HRBP to przypisanie do opiekuna obszaru. Domyslnie SUPERVISOR.
         * @param {string} [employeeId] Osoba, ktorej ludzi chcemy zobaczyc. Bez niej wracaja osoby majace kogos pod soba.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readStructurePeople: async (axis?: SupervisorAxisDto, employeeId?: string, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/structure/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (axis !== undefined) {
                localVarQueryParameter['axis'] = axis;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructureBrowserApi - functional programming interface
 * @export
 */
export const StructureBrowserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructureBrowserApiAxiosParamCreator(configuration)
    return {
        /**
         * Zasila przegladarke struktury w panelu admina. Zwraca wylacznie osoby, na ktore da sie zalogowac: aktywnego pracownika z wlaczonym kontem i przynajmniej jedna nadana rola. Bez wskazanej osoby wracaja ci, ktorzy maja kogos pod soba; ze wskazana — jej ludzie. Odczyt wylacznie dla administratora: pokazuje przypisane role, ktore nie naleza do danych ogladanych przez przelozonych. 
         * @summary People in the org structure with their account state (JAIN-489)
         * @param {SupervisorAxisDto} [axis] SUPERVISOR to linia przelozonych, HRBP to przypisanie do opiekuna obszaru. Domyslnie SUPERVISOR.
         * @param {string} [employeeId] Osoba, ktorej ludzi chcemy zobaczyc. Bez niej wracaja osoby majace kogos pod soba.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readStructurePeople(axis?: SupervisorAxisDto, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructurePeopleResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readStructurePeople(axis, employeeId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StructureBrowserApi.readStructurePeople']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StructureBrowserApi - factory interface
 * @export
 */
export const StructureBrowserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructureBrowserApiFp(configuration)
    return {
        /**
         * Zasila przegladarke struktury w panelu admina. Zwraca wylacznie osoby, na ktore da sie zalogowac: aktywnego pracownika z wlaczonym kontem i przynajmniej jedna nadana rola. Bez wskazanej osoby wracaja ci, ktorzy maja kogos pod soba; ze wskazana — jej ludzie. Odczyt wylacznie dla administratora: pokazuje przypisane role, ktore nie naleza do danych ogladanych przez przelozonych. 
         * @summary People in the org structure with their account state (JAIN-489)
         * @param {SupervisorAxisDto} [axis] SUPERVISOR to linia przelozonych, HRBP to przypisanie do opiekuna obszaru. Domyslnie SUPERVISOR.
         * @param {string} [employeeId] Osoba, ktorej ludzi chcemy zobaczyc. Bez niej wracaja osoby majace kogos pod soba.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readStructurePeople(axis?: SupervisorAxisDto, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<StructurePeopleResultDto> {
            return localVarFp.readStructurePeople(axis, employeeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructureBrowserApi - interface
 * @export
 * @interface StructureBrowserApi
 */
export interface StructureBrowserApiInterface {
    /**
     * Zasila przegladarke struktury w panelu admina. Zwraca wylacznie osoby, na ktore da sie zalogowac: aktywnego pracownika z wlaczonym kontem i przynajmniej jedna nadana rola. Bez wskazanej osoby wracaja ci, ktorzy maja kogos pod soba; ze wskazana — jej ludzie. Odczyt wylacznie dla administratora: pokazuje przypisane role, ktore nie naleza do danych ogladanych przez przelozonych. 
     * @summary People in the org structure with their account state (JAIN-489)
     * @param {SupervisorAxisDto} [axis] SUPERVISOR to linia przelozonych, HRBP to przypisanie do opiekuna obszaru. Domyslnie SUPERVISOR.
     * @param {string} [employeeId] Osoba, ktorej ludzi chcemy zobaczyc. Bez niej wracaja osoby majace kogos pod soba.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureBrowserApiInterface
     */
    readStructurePeople(axis?: SupervisorAxisDto, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<StructurePeopleResultDto>;

}

/**
 * StructureBrowserApi - object-oriented interface
 * @export
 * @class StructureBrowserApi
 * @extends {BaseAPI}
 */
export class StructureBrowserApi extends BaseAPI implements StructureBrowserApiInterface {
    /**
     * Zasila przegladarke struktury w panelu admina. Zwraca wylacznie osoby, na ktore da sie zalogowac: aktywnego pracownika z wlaczonym kontem i przynajmniej jedna nadana rola. Bez wskazanej osoby wracaja ci, ktorzy maja kogos pod soba; ze wskazana — jej ludzie. Odczyt wylacznie dla administratora: pokazuje przypisane role, ktore nie naleza do danych ogladanych przez przelozonych. 
     * @summary People in the org structure with their account state (JAIN-489)
     * @param {SupervisorAxisDto} [axis] SUPERVISOR to linia przelozonych, HRBP to przypisanie do opiekuna obszaru. Domyslnie SUPERVISOR.
     * @param {string} [employeeId] Osoba, ktorej ludzi chcemy zobaczyc. Bez niej wracaja osoby majace kogos pod soba.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureBrowserApi
     */
    public readStructurePeople(axis?: SupervisorAxisDto, employeeId?: string, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return StructureBrowserApiFp(this.configuration).readStructurePeople(axis, employeeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

